module.exports = __webpack_public_path__ + "921ae75e66608af46294de91e2baa9ce.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dtg-tshirt-white-design-resized.png
// module id = 781
// module chunks = 0